export default function HeroSection() {
  return (
    <section
      className="relative bg-gradient-to-br from-blue-50 to-white overflow-hidden"
      id="home"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-24 flex flex-col-reverse md:flex-row items-center gap-16">

        {/* Left Content */}
        <div className="md:w-1/2 text-center md:text-left space-y-6">

          {/* Small Highlight */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-700 text-sm font-medium">
            🎓 Admissions Open • Diploma in Elementary Education (D.el.ed-PTC)
          </div>

          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
            Welcome to{" "}
            <span className="text-blue-600">
              Jivan Jyoti Trust
            </span>
          </h2>

          <p className="text-lg text-gray-700 leading-relaxed">
            Empowering Lives Through Education Since 1962.
            <br />
            For over six decades, we’ve provided quality education and support
            to underserved communities in Ahmedabad, Gujarat — transforming
            dreams into reality for thousands of students and families.
          </p>

          {/* Added separately so paragraph remains clean */}
          <p className="text-blue-700 font-medium">
            Now offering Diploma in Elementary Education (D.el.ed-PTC).
          </p>

          <ul className="text-gray-600 text-sm space-y-2 pt-2">
            <li>✅ Best & Affordable Education</li>
            <li>✅ Girls’ Education & Upliftment</li>
            <li>✅ Community & Family Support</li>
            <li>✅ Vocational Training & Health Awareness</li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start pt-4">
            
            {/* Keep existing */}
            <a
              href="#contact"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium shadow-lg transition cursor-pointer"
            >
              Donate Now
            </a>

            {/* Replace second CTA */}
            <a
              href="/siddharth-ptc-collage"
              className="border border-blue-600 text-blue-600 hover:bg-blue-50 px-6 py-3 rounded-lg font-medium transition cursor-pointer"
            >
              Explore D.el.ed – PTC
            </a>

          </div>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2">
          <div className="relative w-full max-w-md mx-auto">
            <img
              src={require("../assets/student.png")}
              alt="Student smiling"
              className="rounded-xl shadow-md"
            />

            {/* Floating Badge — unchanged */}
            <div className="absolute z-10 -bottom-6 -right-6 bg-white px-6 py-4 rounded-xl shadow-lg border-l-4 border-blue-600 text-left max-w-xs">
              <p className="text-sm text-gray-500">Since 1962</p>
              <p className="text-lg font-semibold text-blue-700">
                Thousands of Lives Empowered
              </p>
              <p className="text-sm text-gray-600">
                Transforming education in underserved communities
              </p>
            </div>

            {/* Background Blob */}
            <div className="absolute -top-10 -left-10 w-full h-full opacity-30 pointer-events-none blur-3xl -z-10">
              <svg
                viewBox="0 0 200 200"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full animate-blob-slow -z-10"
              >
                <path
                  fill="#3B82F6"
                  d="M53.3,-68.7C67.2,-58.6,76.9,-39.5,77.8,-21.6C78.7,-3.8,70.9,13,60.2,26.4C49.5,39.9,36,50.1,21.4,56.3C6.8,62.5,-9,64.7,-25.2,60.7C-41.4,56.7,-57.9,46.4,-67.3,31.5C-76.7,16.7,-78.9,-2.6,-71.8,-17.9C-64.7,-33.1,-48.3,-44.2,-32.3,-54.3C-16.3,-64.4,-0.6,-73.4,16.9,-77.2C34.3,-81.1,53.3,-79,53.3,-68.7Z"
                  transform="translate(100 100)"
                />
              </svg>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
} 